import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./layouts/Header/Header";
import { Home } from "./components/Home";
import { Results } from "./components/Results";
import { ResultDetail } from "./components/ResultDetail";
import { HOME_PAGE, RESULTS_PAGE, PRODUCT_PAGE } from "./routes";
import React, { FC } from "react";

export const App: FC = () => (
  <BrowserRouter>
    <Header />
    <Routes>
      <Route path={HOME_PAGE} element={<Home />} />
      <Route path={RESULTS_PAGE} element={<Results />} />
      <Route path={PRODUCT_PAGE} element={<ResultDetail />} />
    </Routes>
  </BrowserRouter>
);
